import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import Item from "./components/Item";

var LanguageSwitcher = function LanguageSwitcher(_ref) {
  var children = _ref.children,
      heading = _ref.heading;
  var getClassName = getClassNameFactory(LanguageSwitcher.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("h2", {
    className: getClassName({
      descendantName: "heading",
      utilities: "typographySmallCaps"
    })
  }, heading), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "items"
    })
  }, children));
};

LanguageSwitcher.displayName = "LanguageSwitcher";
LanguageSwitcher.Item = Item;
export default LanguageSwitcher;